<template>
    <div class="aktas-view">
        <AktaSearchComponent />
    </div>
</template>

<script>
import AktaSearchComponent from '@/components/app/akta_components/AktaSearchComponent.vue';

export default {

    components: {
        AktaSearchComponent
    }
}
</script>

<style>

</style>
